import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate, Routes, Route } from 'react-router-dom';

import Menu from './components/Menu/Menu';
import Contacts from './components/Contacts/Contacts';
import Delivery from './components/Delivery/Delivery';
import Available from './components/Available/Available';
import Main from './components/Main/Main';
import Orders from './components/Orders/Orders';
import More from './components/More/More';
import AuthGate from './common/AuthGate';
import AppShell from './common/AppShell';

function App() {
  return (
    <AuthGate>
      <AppShell>
        <ToastContainer />
        <Routes>
          <Route exact path="/" element={<Main />} />
          <Route exact path="/admin-shd" element={<Navigate to="/" replace />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/more" element={<More />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/available" element={<Available />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppShell>
    </AuthGate>
  );
}

export default App;
